export default __webpack_public_path__ + "static/media/021-sea urchin.4ff3846f.svg";